<template>
	<el-dialog title="选择地点" v-model="isAddress" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page-container">
			<div class="top-content">
				地址:
				<div class="searchbox mr-10 ml-20">
					<input style="width: 400px;" type="text" id="input_id" v-model="address" placeholder="输入详细地址"
						@keyup.enter="handleEnter" />
				</div>
				当前坐标: {{ point[0] }}, {{ point[1] }}
				<span class="btn bg-default mr-10 ml-20" v-on:click="submit()">确认地址</span>
			</div>
			<div id="map-container">
				<div id="container"></div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		throwStatement
	} from "@babel/types";
	export default defineComponent({
		name: "Address",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getAddressData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			let autoComplete = null;
			let placeSearch = null;

			const getAddressData = (addressvaule, lng, lat) => {
				context.emit("getAddressData", addressvaule, lng, lat);
			};
			onMounted(() => {
				nextTick(() => {
					// data.mapHeight = document.querySelector(" #map-container").offsetHeight;
					initMap();

				});
			});
			const data = reactive({
				isAddress: false,
				searchWord: "",
				mapHeight: 400,

				center: [115.97539, 28.715532], //地图中心点
				point: [], //经纬度-lng lat
				map: null, //地图实例
				marker: null, //地图icon
				geocoder: null, //逆解析实例
				address: null, //地址

			});
			//重置数据
			const init = (addressvalue, Lnglatvalue) => {
				data.isAddress = true;
				data.center = [115.97539, 28.715532]; //地图中心点
				data.point = []; //经纬度-lng lat
				//data.map = null; //地图实例
				//data.marker = null; //地图icon
				//data.geocoder = null; //逆解析实例

				if (data.address !== '') {
					data.address = addressvalue; //地址
					let Lnglat = Lnglatvalue.split(',');
					data.point = [Lnglat[0], Lnglat[1]];
				}


				if (data.map !== null) {
					if (data.address !== null && data.address !== undefined && data
						.address !== "") {
						addMarker();
						data.map.panTo(data.point);
					}
				}

			};

			//初始化地图
			const initMap = () => {
				AMapLoader.load({
						key: "e43a295f15ed06c429ff79a20f5331f0",
						version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
						plugins: [
							"AMap.Geolocation",
							"AMap.AutoComplete",
							"AMap.PlaceSearch",
							"AMap.Geocoder",
							"AMap.IndexCluster",
						], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
						AMapUI: {
							// 是否加载 AMapUI，缺省不加载
							version: "1.1", // AMapUI 版本
							plugins: ["overlay/SimpleMarker"], // 需要加载的 AMapUI ui插件
						},
						Loca: {
							// 是否加载 Loca， 缺省不加载
							version: "2.0", // Loca 版本
						},
					})
					.then((AMap) => {
						// console.log(AMap)
						data.map = new AMap.Map("container", {
							//设置地图容器id
							viewMode: "3D", //是否为3D地图模式
							zoom: 10, //初始化地图级别
							center: [113.683515, 34.752721], //初始化地图中心点位置
							animateEnable: false,
						});

						AMap.plugin(["AMap.AutoComplete", "AMap.PlaceSearch"], function() {
							const autoOptions = {
								//城市，默认全国
								city: "全国",
								//使用联想输入的 input 的 id
								input: "input_id",
							};
							autoComplete = new AMap.AutoComplete(autoOptions);
							placeSearch = new AMap.PlaceSearch({
								city: "全国",
								map: data.map,
							});
							autoComplete.on("select", function(e) {
								//针对选中的poi实现自己的功能
								console.log("选中的位置：", e.poi.name);
								console.log("经纬度：", e.poi.location);
								data.point = [];
								data.address = e.poi.name;
								Geocoder(data.address);
							});
						});


						//监听用户的点击事件
						data.map.on('click', e => {
							console.log('点击位置:', e.lnglat); // e.lnglat是点击位置的经纬度对象
							let lng = e.lnglat.lng
							let lat = e.lnglat.lat
							data.point = [lng, lat]
							// 增加点标记
							addMarker();
							// 获取地址
							getAddress();
						})

						if (data.address !== null && data.address !== undefined && data
							.address !== "") {
							addMarker();
							data.map.panTo(data.point);
						}


					}).catch(e => {
						console.error(e);
					});
			};


			// 增加点标记
			const addMarker = () => {
				// 清除其他icon
				if (data.marker !== null) {
					data.marker.setMap(null)
					data.marker = null
				}
				// 重新渲染icon
				// data.marker = new AMap.Marker({
				// 	icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
				// 	position: data.point, //icon经纬度
				// 	offset: new AMap.Pixel(-13, -30) //icon中心点的偏移量
				// })
				data.marker = new AMap.Marker({
					map: data.map,
					position: data.point,
					animation: "AMAP_ANIMATION_DROP"
				})
				data.marker.setMap(data.map) //设置icon
			};

			// 将经纬度转换为地址
			const getAddress = () => {
				// 这里通过高德 SDK 完成。
				var geocoder = new AMap.Geocoder({
					city: '全国', //地理编码时，设置地址描述所在城市; 默认全国; 可选值：城市名（中文或中文全拼）、citycode、adcode
					radius: 1000, //逆地理编码时，以给定坐标为中心点; 默认1000; 取值范围(0-3000)
					extensions: 'all' //逆地理编码时，返回信息的详略; 默认值：base，返回基本地址信息; 默认值：base，返回基本地址信息
				})

				//调用逆解析方法 个人开发者调用量上限5000（次/日）
				geocoder.getAddress(data.point, function(status, result) {
					if (status === 'complete' && result.info === 'OK') {
						if (result && result.regeocode) {
							// this指向改变
							data.address = result.regeocode.formattedAddress
						}
					}
				})
			};

			// 重写AAddress.js 的 Geocoder 方法 通过地址查找
			const Geocoder = (addr) => {
				if (addr != null && addr != "") {
					// document.getElementById("road").value = addr;
					var geocoder = new AMap.Geocoder({
						radius: 1000
					});

					geocoder.getLocation(addr, function(status, result) {
						console.log(status);
						console.log(result);
						if (status === 'complete' && result.info === 'OK') {
							geocoder_CallBack(result);

						} else {
							alert("没有搜索到您查找的地址！");
							proxy.$message.error("没有搜索到您查找的地址！");
						}
					})
				} else {}
			};

			//通过地址查找，获取经纬度
			const geocoder_CallBack = (resdata) => {
				var resultStr = "";
				var geocode = resdata.geocodes;
				if (geocode.length > 0) {
					AddPosition(geocode[0].location.getLng(), geocode[0].location.getLat())
				} else {
					alert("没有搜索到您查找的地址！")
				}
			};

			//通过地址查找，获取经纬度，添加标注
			const AddPosition = (lng, lat, radius) => {
				// 清除其他icon
				if (data.marker !== null) {
					data.marker.setMap(null)
					data.marker = null
				}

				data.point = [lng, lat]
				data.map.panTo(data.point);
				// 重新渲染icon
				// data.marker = new AMap.Marker({
				// 	icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
				// 	position: data.point, //icon经纬度
				// 	offset: new AMap.Pixel(-13, -30) //icon中心点的偏移量
				// })
				// data.marker.setMap(data.map) //设置icon

				data.marker = new AMap.Marker({
					map: data.map,
					position: data.point,
					animation: "AMAP_ANIMATION_DROP"
				})
				data.marker.setMap(data.map) //设置icon

			};

			//输入框回车查找地址
			const handleEnter = () => {
				// 处理回车事件，例如提交表单或进行其他操作
				console.log('回车键被按下，输入值为:', data.address);
				// 这里可以添加更多的逻辑，比如调用API发送数据等
				data.point = [];
				Geocoder(data.address);
			};

			const dialogClosedHandle = () => {
				data.isAddress = false;
				// 清除其他icon
				if (data.marker !== null) {
					data.marker.setMap(null)
					data.marker = null
				}
			};

			const submit = async () => {
				if (data.point.length === 0) {
					proxy.$message.error("请先获取地址再确认");
					return;
				}
				data.isAddress = false;
				getAddressData(data.address, data.point[0], data.point[1]);
			};

			return {
				...toRefs(data),
				init,
				getAddressData,
				dialogClosedHandle,
				submit,
				getAddress,
				addMarker,
				Geocoder,
				handleEnter,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}



	.page-container {
		width: 100%;
		/* height: 100%; */
		height: 500px;
	}

	.page-container .top-content {
		width: calc(100% - 50px);
		height: 70px;
		padding: 0 25px;
		margin-bottom: 20px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	#map-container {
		width: 100%;
		height: 400px;
		/* height: calc(100% - 100px); */
		/* position: relative; */
	}

	#container {
		width: 100%;
		height: 400px;
	}
</style>